import { Button, IconButton, InputAdornment, TextField } from "@mui/material";
import React, { Fragment, useContext, useEffect, useState } from "react";
import { FiPlus } from "react-icons/fi";
import { PagedDataView } from "../../lists/PagedDataView/PagedDataView";
import { api, IPackageList, IUpsellsPackageList, UpsellPackage } from "../../../logic/api";

import SearchIcon from "@mui/icons-material/Search";
import SwitchField from "../../editable/EditableField/fields/SwitchField";
import flex from "../../../styles/flex";
import { isAdmin } from "../../../utility/utils";
import { SessionContext } from "../../../utility/useSession";
import UpsellPackageListItem from "./listItem/UpsellPackageListItem";
import UpsellsBuilder from "../builder/UpsellsBuilder";
import { useTranslation } from "react-i18next";
import { useUserPermissions } from "@/hooks/useUserPermissions";
import { useReleaseManagement, ReleaseFlag } from "@/utility/feature-management";

const UpsellsManager = () => {
  const [selectedPackage, setSelectedPackage] = useState<UpsellPackage | null>(null);
  const [showCreatePackage, setShowCreatePackage] = useState<boolean>(false);
  const [packageListFetchParams, setPackageListFetchParams] = useState<IUpsellsPackageList>({
    includeExpired: true,
  });
  const [filter, setFilter] = useState("");
  const session = useContext(SessionContext);
  const { t } = useTranslation();
  const { hasPermission } = useUserPermissions();
  const isRbacReleased = useReleaseManagement(ReleaseFlag.releaseRbac);

  const PackageDialog = () => {
    return <UpsellsBuilder upsellPackageId={selectedPackage == null ? null : selectedPackage.id} show={showCreatePackage} onClose={(didUpdate) => {
      setSelectedPackage(null);
      setShowCreatePackage(false);
      if (didUpdate == true) {
        setPackageListFetchParams({ ...packageListFetchParams });
      }
    }}></UpsellsBuilder>;
  };



  const carParkId = (session.current.site == null || session.current.site.home == null) ? null : session.current.site.home.id;
  const [currentCarParkId, setCurrentCarParkId] = useState(carParkId);

  useEffect(() => {
    if (carParkId != currentCarParkId) {
      setCurrentCarParkId(carParkId);
      setPackageListFetchParams({ ...packageListFetchParams });
    }
  }, [carParkId]);

  return (
    <div>
      <PackageDialog />
      <div style={{ padding: 10, textAlign: "right" }}>
        <div style={flex.flexRows}>
          <div style={flex.flexAuto}>
            <TextField
              autoFocus={false}
              label={t("upsells.searchUpsells")}
              variant="outlined"
              size="small"
              type="search"
              value={filter}
              onChange={(e) => {
                setFilter(e.currentTarget.value);
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  e.stopPropagation();
                  if (e.currentTarget) {
                    e.currentTarget.blur();
                    setPackageListFetchParams({ ...packageListFetchParams, filter: filter });
                  }
                  return false;
                }

              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position={"end"}>
                    <IconButton
                      style={{ padding: 0 }}
                      onClick={() => {
                        setPackageListFetchParams({ ...packageListFetchParams, filter: filter });
                      }}
                    >
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
          </div>
          {isAdmin(session) && (
            <Fragment>
              <div style={flex.flexAuto}>
                <SwitchField onChange={(includeInactive) => {
                  setPackageListFetchParams({ ...packageListFetchParams, includeInactive: includeInactive });
                }} value={packageListFetchParams.includeInactive} ></SwitchField>
              </div>
              <div style={flex.flexAuto}>
                <div style={{ textAlign: "right", paddingTop: 10, color: "grey" }}>
                  {t("packages.incInactive")}
                </div>
              </div>
              <div style={flex.flexAuto}>
                <SwitchField onChange={(includeExpired) => {
                  setPackageListFetchParams({ ...packageListFetchParams, includeExpired: includeExpired });
                }} value={packageListFetchParams.includeExpired} ></SwitchField>
              </div>
              <div style={flex.flexAuto}>
                <div style={{ textAlign: "right", paddingTop: 10, color: "grey" }}>
                  {t("packages.incExpired")}
                </div>
              </div>
            </Fragment>
          )}


          <div style={flex.flexFill}>

          </div>
          {(isRbacReleased ? hasPermission("bookingManagement.upsells.create") : isAdmin(session)) && (
            <div style={flex.flexAuto}>
              <Button style={{ marginLeft: 10 }} variant="contained" color="secondary" onClick={() => {
                setSelectedPackage(null)
                setShowCreatePackage(true);
              }}><FiPlus style={{ marginRight: 10 }}></FiPlus>{t("upsells.newUpsell")}</Button>
            </div>
          )}

        </div>
      </div>
      <PagedDataView<IPackageList, UpsellPackage>
        apiHook={api.hooks.upsell.list}
        parameters={packageListFetchParams}
        renderItem={(item) => {
          return <UpsellPackageListItem upsellPackage={item} onEditPackage={() => {
            setSelectedPackage(item);
            setShowCreatePackage(true);
          }}></UpsellPackageListItem>
        }}>
        <div style={{ padding: 20, backgroundColor: "#eee" }}>
          {t("upsells.noUpsells")}
        </div>
      </PagedDataView>
    </div >
  );
}

export default UpsellsManager;
